import { IFormStatus } from './SecurePaymentFields/SecurePaymentFields.types';

export const markEmptyFieldsInvalid = (fields: IFormStatus['fields']) => {
  return Object.fromEntries(
    Object.entries(fields).map(([key, field]) => [key, field.empty ? { ...field, valid: false } : field])
  ) as IFormStatus['fields'];
};
